/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { cloneDeep } from 'lodash';
import { TableFilters } from './filter-normalization.utils';

export function withArchivedStatusTransform(filters: TableFilters): TableFilters {
  const result = cloneDeep(filters);
  const statusFilter = result['status'];
  if (statusFilter && !Array.isArray(statusFilter)) {
    const statuses = statusFilter.value;
    if (Array.isArray(statuses) && statuses.includes('archived')) {
      statuses.splice(statuses.indexOf('archived'), 1);
      if (statuses.length === 0) {
        delete result['status'];
      }
      result['archivedStatus'] = { value: true, matchMode: 'equals' };
    }
  }
  return result;
}
